// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"383":"37a1cd88","922":"b8964a64"}[chunkId] + ".js";
};